import { defineElement, html } from '@webtides/element-js';
import SpecFilter from '../spec-filter/SpecFilter';

class SpecBoxFilter extends SpecFilter {
    events() {
        return Object.assign(super.events(), {
            button: {
                click: e => {
                    const { index } = e.currentTarget.dataset;
                    this.changeSelection(index);
                },
            },
        });
    }

    getColorClasses(index) {
        if (this.disabled.includes(index)) {
            return 'is-disabled';
        } else if (!!this.values[index].selected) {
            return `is-active`;
        }
    }

    renderValues() {
        return html`
            <div class="text-center lg:text-left pt-1">
                ${this.values.map(
                    (value, index) =>
                        html`
                            <button
                                class="btn btn-toggle normal-case mr-2 mb-2 ${this.getColorClasses(index)}"
                                data-index="${index}"
                                ?disabled="${this.disabled.includes(index)}"
                            >
                                ${value.label}
                            </button>
                        `,
                )}
            </div>
        `;
    }
}

defineElement('spec-box-filter', SpecBoxFilter);
